module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.$store.state.userInfo) ? _c('li', {
    staticClass: "session-profile"
  }, [_c('el-dropdown', {
    staticClass: "header-dropdown-devin",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleLogout
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.state.userInfo.avatar ? _vm.$store.state.userInfo.avatar : '/static/img/avatar-bg.png',
      "alt": "avatar"
    }
  }), _vm._v("\n              " + _vm._s(_vm.$store.state.userInfo.nickname) + "\n              "), (_vm.$store.getters.isAdmin) ? _c('strong', {
    staticClass: "auth-tag"
  }, [_vm._v("管理员")]) : _vm._e()]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("退出")])], 1)], 1)], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('b', [_c('img', {
    attrs: {
      "src": "/static/img/logo.png",
      "alt": "User Image"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('b', [_vm._v("选型宝")]), _vm._v("管理后台\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-80d7d13a!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = 472
// module chunks = 11